<div style="text-align: center; padding: 20%">
    <h4>You are not authorized to view this page</h4>
    </div>